module.exports = __webpack_public_path__ + "static/media/G0142657_China-14.80dd0d06.png";